module.exports = "<ul>\n  <li *ngFor=\"let x of (cards)\" class=\"cards\">\n    <img src=\"../assets/{{x.suit}}S/{{x.value}}{{x.suit}}S.png\" alt=\"{{x}}\" *ngIf=\"!x.doubleDown\">\n    <img src=\"../assets/cardBack.jpg\" alt=\"{{x}}\" *ngIf=\"x.doubleDown\">\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cards/cards.component.html
// module id = ./src/app/cards/cards.component.html
// module chunks = main